<template>
  <div class="header">
    <div class="logo-box">
      <div class="logo">众望智慧管理平台</div>
    </div>
    <div class="right">
      <span class="btn-refush" @click="refreshCache">刷新缓存</span>
      <EditPassword />
      <div class="user">
        <span>您好！</span>
        <span class="user-name">{{ userInfo.name }}</span>
      </div>
      <div class="logout" @click="handleLogout">
        <el-tooltip class="item" effect="dark" content="退出" placement="top">
          <i class="el-icon-switch-button"></i>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EditPassword from '@/components/PermissionPassword/EditPassword';
import Vue from 'vue';
import config from '../../config/index.js';
export default {
  components: {
    EditPassword
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    ...mapActions(['logout']),

    // 退出
    handleLogout() {
      this.logout().then(() => {
        this.$message({
          message: '安全退出',
          type: 'success'
        });
        this.$router.replace('/login');
      });
    },
    refreshCache() {
      //刷新登录配置缓存
      Vue.axios.get(`${config.base_url}/roses-platform/refreshCache`);
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo-box {
    box-sizing: border-box;
    width: 200px;
    height: 64px;
    line-height: 64px;
    padding-left: 8px;
    background-color: #272b38;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);

    .logo {
      padding-left: 37px;
      background: url('~assets/images/logo-color.png') no-repeat center left;
      background-size: 37px;
      font-size: 17px;
      color: #fff;
    }
  }

  .right {
    display: flex;
    justify-content: space-between;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #303133;

    .user {
      padding-right: 16px;
      margin-left: 40px;
      .user-name {
        color: #409dff;
        // cursor: pointer;
      }
    }

    .logout {
      border-left: 2px solid #90939b;
      padding: 0 16px;
      font-size: 24px;
      color: #303133;
      font-weight: 700;
      cursor: pointer;
    }
  }
}
.btn-refush {
  margin: 0 30px;
  cursor: pointer;
  color: #409dff;
}
</style>
